import React, { useState } from "react"
import clsx from "clsx"
import pluralize from "pluralize"
import dayjs from "dayjs"

import { Asset, Flag, Icon, Link } from "components"

function Post({ date, href, image, title, category }) {
  const [isHovering, setIsHovering] = useState(false)

  return (
    <article className="h-full">
      <Link
        href={href}
        className="text-darkNavy focus:text-violet flex flex-col h-full"
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        <div
          className={clsx(
            "bg-mineralGray",
            category?.slug === "/"
              ? "aspect-w-5 aspect-h-4 md:aspect-w-4 md:aspect-h-3"
              : "aspect-w-5 aspect-h-4 md:aspect-w-8 md:aspect-h-5"
          )}
        >
          {image && (
            <Asset
              asset={image}
              objectFit="cover"
              objectPosition="center"
              style={{ position: "absolute" }}
            />
          )}
          <div className="z-flag md:pl-8 flex items-end pl-6">
            {category?.slug !== "/" && (
              <Flag
                label={pluralize.singular(category?.name)}
                appearance="primary"
              />
            )}
          </div>
        </div>
        <div
          className={clsx(
            "flex flex-col justify-between flex-1 p-6 space-y-6 bg-white",
            category?.slug === "/" ? "md:space-y-4" : "md:p-8 md:space-y-8"
          )}
        >
          <p
            className={clsx(
              "text-current",
              category?.slug === "/" ? "lead-bold" : "h4"
            )}
          >
            {title}
          </p>
          <div
            className={clsx(
              "flex items-center justify-center transform transition-transform ease-out duration-300 w-6 h-6",
              isHovering === true && "translate-x-2"
            )}
          >
            <Icon
              aria-hidden
              className="text-violet"
              symbol="arrow-right"
              size={24}
            />
          </div>
          {category?.slug === "/" && date && (
            <p className="body text-darkNavy">
              {dayjs(date).format("MMM DD, YYYY")}
            </p>
          )}
        </div>
      </Link>
    </article>
  )
}

export default Post
